import { render, staticRenderFns } from "./ScholarshipFooter.vue?vue&type=template&id=c85de5f4&scoped=true&"
import script from "./ScholarshipFooter.vue?vue&type=script&lang=js&"
export * from "./ScholarshipFooter.vue?vue&type=script&lang=js&"
import style0 from "./ScholarshipFooter.vue?vue&type=style&index=0&id=c85de5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85de5f4",
  null
  
)

export default component.exports